import articleCredits from '../img_main/article-credits.png';
import articleCards from '../img_main/article-cards.png';
import articleSecurity from '../img_main/article-security.png';
import catCreditIcon from '../img_main/cat-credit.png';

export const NEWS = [
  {
    slug: 'usloviya-kreditov-avgust-2026',
    title: 'Банки обновили условия по кредитам: что важно знать в августе',
    category: 'Рынок',
    date: '14.08.2026',
    dateISO: '2026-08-14',
    readTime: '6 мин',
    cover: articleCredits,
    lead:
      'В августе сразу несколько банков скорректировали ставки и требования по потребительским кредитам. Разбираем, что изменилось и как сравнить предложения без лишней спешки.',
    facts: [
      { label: 'Что изменилось', value: 'Ставки и требования к доходу' },
      { label: 'Кому важно', value: 'Заёмщикам и тем, кто рефинансирует' },
      { label: 'Что делать', value: 'Сравнить 3–5 предложений' },
    ],
    cta: {
      to: '/consumer-loans',
      label: 'Сравнить кредиты',
      text: 'Актуальные условия по потребительским кредитам — в одном каталоге.',
    },
    toc: [
      { id: 'chto-proizoshlo', title: 'Что произошло' },
      { id: 'pochemu-vazhno', title: 'Почему это важно' },
      { id: 'chto-izmenitsya', title: 'Что изменится для заёмщиков' },
      { id: 'chto-delat', title: 'Что делать дальше' },
    ],
    blocks: [
      {
        type: 'p',
        text: 'На рынке потребительского кредитования снова заметна перестановка условий. Банки уточняют диапазоны ставок, пересматривают лимиты и усиливают проверку платёжеспособности. Для пользователя это значит одно: сравнивать предложения стало ещё важнее.',
      },
      {
        type: 'h2',
        id: 'chto-proizoshlo',
        text: 'Что произошло',
      },
      {
        type: 'p',
        text: 'По обновлённым карточкам банков видно: часть продуктов стала жёстче по входу, а часть — прозрачнее по сроку и сумме. В каталоге ЕнотМани уже отражены актуальные параметры по ключевым предложениям.',
      },
      {
        type: 'quote',
        text: 'Даже небольшая разница в ставке на длинном сроке меняет переплату сильнее, чем кажется на первый взгляд.',
      },
      {
        type: 'h2',
        id: 'pochemu-vazhno',
        text: 'Почему это важно',
      },
      {
        type: 'p',
        text: 'Если смотреть только на рекламную «ставку от», легко упустить дополнительные условия: страховки, комиссии и требования к документам. Именно поэтому удобнее держать несколько вариантов рядом и сравнивать не один параметр, а весь набор.',
      },
      {
        type: 'facts',
        items: [
          { title: 'Ставка', text: 'Сравнивайте полную стоимость, а не только нижнюю границу.' },
          { title: 'Срок', text: 'Более длинный срок снижает платёж, но увеличивает переплату.' },
          { title: 'Сумма', text: 'Берите столько, сколько реально нужно — лишний лимит удорожает риск.' },
        ],
      },
      {
        type: 'h2',
        id: 'chto-izmenitsya',
        text: 'Что изменится для заёмщиков',
      },
      {
        type: 'p',
        text: 'Тем, кто планирует заявку в ближайшие недели, стоит заранее подготовить документы и оценить комфортный ежемесячный платёж. Тем, у кого уже есть кредит, имеет смысл проверить, не стало ли рефинансирование выгоднее текущего договора.',
      },
      {
        type: 'warning',
        title: 'Важно',
        text: 'Информация носит справочный характер и не является офертой. Итоговые условия подтверждаются на сайте банка при оформлении.',
      },
      {
        type: 'h2',
        id: 'chto-delat',
        text: 'Что делать дальше',
      },
      {
        type: 'ol',
        items: [
          'Определите сумму и срок, которые вам реально подходят.',
          'Сравните несколько банков по ставке, сумме и сроку.',
          'Проверьте дополнительные платежи и условия досрочного погашения.',
          'Подавайте заявку только туда, где условия понятны.',
        ],
      },
      {
        type: 'h3',
        text: 'Короткий вывод',
      },
      {
        type: 'p',
        text: 'Августовские обновления не означают, что рынок стал «хуже» или «лучше» для всех. Они означают, что выбор стал более индивидуальным — и сравнение снова экономит деньги и время.',
      },
    ],
  },
  {
    slug: 'keshbek-karty-novye-kategorii',
    title: 'Новые категории кэшбэка: какие карты выгоднее в повседневных тратах',
    category: 'Карты',
    date: '10.08.2026',
    dateISO: '2026-08-10',
    readTime: '5 мин',
    cover: articleCards,
    lead:
      'Банки обновили категории повышенного кэшбэка. Смотрим, как выбрать карту под продукты, АЗС и онлайн-покупки.',
    facts: [
      { label: 'Фокус', value: 'Категории и лимиты' },
      { label: 'Для кого', value: 'Владельцы дебетовых карт' },
      { label: 'Результат', value: 'Больше реальной выгоды' },
    ],
    cta: {
      to: '/cards',
      label: 'Смотреть карты',
      text: 'Сравните кэшбэк и обслуживание дебетовых карт.',
    },
    toc: [
      { id: 'obzor', title: 'Что изменилось' },
      { id: 'kak-vybrat', title: 'Как выбрать карту' },
      { id: 'oshibki', title: 'Частые ошибки' },
    ],
    blocks: [
      {
        type: 'p',
        text: 'Выгода по карте зависит не от максимального процента в рекламе, а от того, совпадают ли категории с вашими тратами и не упираетесь ли вы в месячный лимит.',
      },
      {
        type: 'h2',
        id: 'obzor',
        text: 'Что изменилось',
      },
      {
        type: 'p',
        text: 'В обновлённых предложениях чаще встречаются понятные категории на продукты, транспорт и онлайн. Одновременно банки жёстче фиксируют потолок возврата.',
      },
      {
        type: 'h2',
        id: 'kak-vybrat',
        text: 'Как выбрать карту',
      },
      {
        type: 'ul',
        items: [
          'Оцените 3–4 основные статьи расходов.',
          'Сверьте лимит кэшбэка в месяц.',
          'Проверьте стоимость обслуживания.',
          'Сравните несколько карт в каталоге до оформления.',
        ],
      },
      {
        type: 'h2',
        id: 'oshibki',
        text: 'Частые ошибки',
      },
      {
        type: 'warning',
        title: 'На заметку',
        text: 'Не открывайте карту ради разовой акции, если дальше обслуживание станет платным без понятной выгоды.',
      },
    ],
  },
  {
    slug: 'bezopasnost-platezhey-leto-2026',
    title: 'Мошенники усиливают схемы: простые правила защиты счетов летом',
    category: 'Безопасность',
    date: '05.08.2026',
    dateISO: '2026-08-05',
    readTime: '4 мин',
    cover: articleSecurity,
    lead:
      'Сезон отпусков — традиционный пик фишинга и поддельных звонков. Напоминаем базовые правила, которые реально работают.',
    facts: [
      { label: 'Риск', value: 'Фишинг и социнженерия' },
      { label: 'Защита', value: 'Коды, приложение, уведомления' },
      { label: 'Реакция', value: 'Блокировка карты' },
    ],
    cta: {
      to: '/cards',
      label: 'К картам',
      text: 'Оформляйте продукты только на официальных сайтах банков.',
    },
    toc: [
      { id: 'shemy', title: 'Какие схемы сейчас частые' },
      { id: 'pravila', title: 'Правила защиты' },
      { id: 'esli', title: 'Если уже попали' },
    ],
    blocks: [
      {
        type: 'p',
        text: 'Большинство схем строится на спешке: «подтвердите операцию», «ваш счёт под угрозой», «переведите на безопасный счет». Если появляется давление — это уже сигнал остановиться.',
      },
      {
        type: 'h2',
        id: 'shemy',
        text: 'Какие схемы сейчас частые',
      },
      {
        type: 'ul',
        items: [
          'Поддельные сайты банков и маркетплейсов.',
          'Звонки от имени службы безопасности.',
          'Ссылки в мессенджерах с «срочной проверкой».',
        ],
      },
      {
        type: 'h2',
        id: 'pravila',
        text: 'Правила защиты',
      },
      {
        type: 'ol',
        items: [
          'Не сообщайте коды из SMS и push.',
          'Заходите в банк только через официальное приложение.',
          'Включайте уведомления по операциям.',
        ],
      },
      {
        type: 'h2',
        id: 'esli',
        text: 'Если уже попали',
      },
      {
        type: 'p',
        text: 'Сразу заблокируйте карту в приложении и обратитесь в поддержку банка. Чем быстрее реакция, тем выше шанс остановить сомнительные операции.',
      },
    ],
  },
  {
    slug: 'kreditnye-karty-lgotnyi-period',
    title: 'Льготный период по кредиткам: на что смотреть при выборе',
    category: 'Кредитные карты',
    date: '01.08.2026',
    dateISO: '2026-08-01',
    readTime: '5 мин',
    cover: catCreditIcon,
    lead:
      'Банки снова конкурируют длиной грейса. Разбираем, какие параметры важнее красивой цифры в днях.',
    facts: [
      { label: 'Ключ', value: 'Условия грейса' },
      { label: 'Риск', value: 'Снятие наличных' },
      { label: 'Совет', value: 'Читать исключения' },
    ],
    cta: {
      to: '/auto-loans',
      label: 'Кредитные карты',
      text: 'Сравните лимиты и льготный период в каталоге.',
    },
    toc: [
      { id: 'parametry', title: 'Ключевые параметры' },
      { id: 'isklyucheniya', title: 'Исключения' },
      { id: 'vybor', title: 'Как выбрать' },
    ],
    blocks: [
      {
        type: 'p',
        text: 'Длинный льготный период полезен только если покупки входят в него и вы закрываете задолженность вовремя. Иначе ставка после грейса быстро съедает выгоду.',
      },
      {
        type: 'h2',
        id: 'parametry',
        text: 'Ключевые параметры',
      },
      {
        type: 'facts',
        items: [
          { title: 'Лимит', text: 'Должен закрывать задачу, а не провоцировать лишние траты.' },
          { title: 'Грейс', text: 'Смотрите, какие операции входят в льготный период.' },
          { title: 'Ставка', text: 'Важна после окончания беспроцентного окна.' },
        ],
      },
      {
        type: 'h2',
        id: 'isklyucheniya',
        text: 'Исключения',
      },
      {
        type: 'p',
        text: 'Снятие наличных и некоторые переводы часто не попадают под льготный период. Это стоит проверить до первой крупной операции.',
      },
      {
        type: 'h2',
        id: 'vybor',
        text: 'Как выбрать',
      },
      {
        type: 'p',
        text: 'Сравните 2–3 карты в каталоге, зафиксируйте лимит, грейс и стоимость обслуживания — и только потом оформляйте.',
      },
    ],
  },
];

const bySlug = new Map(NEWS.map((item) => [item.slug, item]));

export const getNewsBySlug = (slug) => bySlug.get(slug) || null;

export const getRelatedNews = (news, limit = 3) => {
  if (!news) return [];
  const same = NEWS.filter((item) => item.slug !== news.slug && item.category === news.category);
  const other = NEWS.filter((item) => item.slug !== news.slug && item.category !== news.category);
  return [...same, ...other].slice(0, limit);
};
